import React, { useState, useEffect } from 'react';
import './Countdown.css';

const Countdown: React.FC = () => {
    const [timeLeft, setTimeLeft] = useState({
        months: 0,
        days: 0,
        hours: 0,
        minutes: 0
    });

    useEffect(() => {
        const targetDate = new Date('2025-06-19T15:00:00'); // Replace with your event date
        const interval = setInterval(() => {
            const now = new Date();
            const totalSeconds = Math.floor((targetDate.getTime() - now.getTime()) / 1000);

            const months = Math.floor(totalSeconds / (30 * 24 * 60 * 60)); // Approximate month
            const days = Math.floor(totalSeconds / (24 * 60 * 60)) % 30; // Remaining days after months
            const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60));
            const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);

            setTimeLeft({ months, days, hours, minutes });
        }, 1000);

        return () => clearInterval(interval); // Cleanup the interval on component unmount
    }, []);

    return (
        <div className='countdown-container'>
            <h2 className="countdown-header">Faltam...</h2>
            <div className="countdown-content">
                <div className="countdown__item">
                    <div className="countdown__time">{timeLeft.months.toString().padStart(2, '0')}</div>
                    <div className="countdown__label">Meses</div>
                </div>
                <div className="countdown__colon">:</div>
                <div className="countdown__item">
                    <div className="countdown__time">{timeLeft.days.toString().padStart(2, '0')}</div>
                    <div className="countdown__label">Dias</div>
                </div>
                <div className="countdown__colon">:</div>
                <div className="countdown__item">
                    <div className="countdown__time">{timeLeft.hours.toString().padStart(2, '0')}</div>
                    <div className="countdown__label">Horas</div>
                </div>
                <div className="countdown__colon">:</div>
                <div className="countdown__item">
                    <div className="countdown__time">{timeLeft.minutes.toString().padStart(2, '0')}</div>
                    <div className="countdown__label">Minutos</div>
                </div>
            </div>
        </div>
    );
};

export default Countdown;
